module.exports = __webpack_public_path__ + "img/banner0305_3.a2cba271.jpg";